module.exports = __webpack_public_path__ + "img/icon-gen-searchpayulog.c608cb7b.png";